import { api } from "@/lib/api";

const SESSION_KEY = "beecenter_sem_session";

export const getSemSession = () => {
  try { return localStorage.getItem(SESSION_KEY) || null; } catch { return null; }
};

export const setSemSession = (sid) => {
  try { localStorage.setItem(SESSION_KEY, sid); } catch {}
};

export const resetSemSession = () => {
  try { localStorage.removeItem(SESSION_KEY); } catch {}
};

export const sendSemMessage = async ({ message, language }) => {
  const session_id = getSemSession();
  const res = await api.post("/sem/chat", { message, session_id, language });
  if (res.data?.session_id) setSemSession(res.data.session_id);
  return res.data;
};
